import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';

const client = generateClient();

// Helper to select the latest item by updatedAt (fallback to createdAt)
const getLatestItem = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) return null;
  return items
    .slice()
    .sort((a, b) => {
      const getTs = (obj) => new Date(obj?.updatedAt || obj?.createdAt || 0).getTime();
      return getTs(b) - getTs(a);
    })[0];
};

export const fetchUserQuizResults = async () => {
  // Helpers to read local cache and format like backend
  const readLocalMBTI = () => {
    try {
      const raw = localStorage.getItem('medmap.mbti.result');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return {
        personalityType: parsed.personalityType,
        // match backend shape (strings)
        recommendedSpecialties: JSON.stringify(parsed.recommendedSpecialties || []),
        scores: JSON.stringify(parsed.scores || {})
      };
    } catch {
      return null;
    }
  };

  const readLocalMedical = () => {
    try {
      const raw = localStorage.getItem('medmap.medical.result');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return {
        // match backend shape (strings)
        bestMatches: JSON.stringify(parsed.bestMatches || []),
        worstMatches: JSON.stringify(parsed.worstMatches || []),
        selectedAnswers: JSON.stringify(parsed.selectedAnswers || [])
      };
    } catch {
      return null;
    }
  };

  try {
    // Try auth path first
    const user = await getCurrentUser();
    if (!user) {
      // Not logged in: fall back to local
      return {
        mbti: readLocalMBTI(),
        medical: readLocalMedical()
      };
    }

    const attributes = await fetchUserAttributes();
    const userId = attributes.sub;

    // Backend fetch
    const [mbtiResponse, medicalResponse] = await Promise.all([
      client.graphql({
        query: queries.listMBTIQuizResults,
        variables: { filter: { userId: { eq: userId } } },
        authMode: 'userPool'
      }),
      client.graphql({
        query: queries.listMedicalQuizResults,
        variables: { filter: { userId: { eq: userId } } },
        authMode: 'userPool'
      })
    ]);

    const mbtiItems = mbtiResponse?.data?.listMBTIQuizResults?.items || [];
    const medicalItems = medicalResponse?.data?.listMedicalQuizResults?.items || [];

    // Return backend results if present; otherwise fallback to local
    return {
      mbti: getLatestItem(mbtiItems) || readLocalMBTI(),
      medical: getLatestItem(medicalItems) || readLocalMedical()
    };
  } catch (error) {
    console.error('Error fetching quiz results (falling back to cache):', error);
    // Total fallback to local cache
    return {
      mbti: readLocalMBTI(),
      medical: readLocalMedical()
    };
  }
};


